module.exports = __webpack_public_path__ + "./img/CategoriasCreacion.978fe25a8d499e80e1dac48399551452.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/Help/CategoriasCreacion.png
// module id = ./public/img/Help/CategoriasCreacion.png
// module chunks = 0